module.exports = __webpack_public_path__ + "img/3_h_uk.038d9ae5.svg";